import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";
/**
 * @description 
 * API接口文档:
 * 分类:cms-apis
 * catalog-product-list-controller
 */
let CatalogProductRestServiceConfig: IRestfulConfigMap = {
    "catalogProductRestService": {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            // 获取单个产品类目
            // getProductCatalog/getSalesCatalog
            query:{
                method: "get",
                path: "api/catalogs/:catalogProductId/products",
                testPath:"api/catalogs/:catalogProductId/products",
                paramDefaults: {
                    catalogProductId:"@catalogProductId",
                    filter: "@filter",
                    sort:"@sort",
                    limit: "@limit",
                    page: "@page",
                    start: "@start",
                    appName:"@appName",
                    appTag:"@appTag"
                },
                needCurrency: true
            },
            // 获取单个产品类目的搜索结果
            // getCatalogResult
            getCatalogResult:{
                method: "get",
                path: "api/catalogs/products/latest",
                testPath:"api/catalogs/products/latest/test",
                paramDefaults: {
                    filter: "@filter",
                    limit: "@limit",
                    page: "@page",
                    sort:"@sort",
                    appName:"@appName",
                    appTag:"@appTag"
                },
                // TODO: config currencyCode
                needCurrency: true
            }
        }
    }
}

export {CatalogProductRestServiceConfig};